export function handleOnEnter(selector) {
	if (typeof selector === 'object') {
		var $cont = selector.find('input[type="text"]');
	} else {
		var $cont = $(selector + ' input[type="text"]');
	}

	$cont.each(function (idx) {
		let $inp = $(this);
		$inp.keypress(function (e) {
			if (e.which == 13) {
				$(this).trigger("enterKey");
				if (typeof $inp.attr('onenter') !== 'undefined') {
					eval($inp.attr('onenter'));
				}
			}
		});
	});
}
